(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-american-football/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-american-football/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_american_football = svs.themes.sport_american_football || {};

  svs.themes.sport_american_football.initStatusStart = function (data) {
    if (svs.themes.sport_american_football.isLive(data.status.id)) {
      if (data.status.id > 36 && data.status.id < 41) {
        return "<div class=\"brick match-status brick-active f-condensed align-center\">Q".concat(data.status.id - 36, "</div>");
      }

      if (data.status.id === 19 || data.status.id === 60 || data.status.id === 61) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 14 || data.status.id === 16 || data.status.id === 17) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      }

      return '';
    } else if (svs.themes.sport_american_football.isEnded(data.status.id)) {
      if (data.status.id === 32) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">ÖT</div>';
      } else if (data.status.id === 26) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">AVBR</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };


  svs.themes.sport_american_football.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);